import React, { useState } from "react";
import { InventoryService } from "../../../network/InventoryService";
import { useNotification } from "../../../../Notifications/NotificationProvider";
import FileUpload from "../../Common/FileUpload";

const RollOutModal = ({
  showRollOutModal,
  setShowRollOutModal,
  onRolloutCreated,
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatchNotification = useNotification();

  const mappingFields = [
    "Merchant Wallet",
    "Device ID",
    "Is this a Key Account?",
    "Deduction Wallet",
    "Charging Plan ID - 1",
    "Charging Plan ID - 2",
    "Charging Plan ID - 3",
  ];

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ];

      if (allowedTypes.includes(file.type) || file.name.endsWith(".csv")) {
        setUploadedFile(file);
      } else {
        dispatchNotification({
          type: "ERROR",
          message: "Please upload only Excel (.xlsx, .xls) or CSV files.",
        });
      }
    }
    event.target.value = "";
  };

  const handleDownloadSample = async () => {
    setIsDownloading(true);
    try {
      const endpoint = `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/rollout-mapping`;
      await InventoryService.downloadSampleFile(
        endpoint,
        "rollout-mapping-sample.xlsx"
      );

      dispatchNotification({
        type: "SUCCESS",
        message: "Sample file downloaded successfully!",
      });
    } catch (error) {
      console.error("Error downloading sample file:", error);
      dispatchNotification({
        type: "ERROR",
        message: "Failed to download sample file. Please try again.",
      });
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    if (!uploadedFile) {
      dispatchNotification({
        type: "ERROR",
        message: "Please upload a mapping file first.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response =
        await InventoryService.uploadRolloutMapping(uploadedFile);

      if (response.is_error === 0) {
        dispatchNotification({
          type: "SUCCESS",
          message: "Rollout mapping uploaded successfully!",
        });

        setUploadedFile(null);
        setShowRollOutModal(false);

        if (onRolloutCreated) {
          onRolloutCreated();
        }
      } else if (response.is_error === 1) {
        throw new Error(response.message || "Failed to upload rollout mapping");
      }
    } catch (error) {
      console.error("Error uploading rollout mapping:", error);

      let errorMessage = "Failed to upload rollout mapping. Please try again.";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      dispatchNotification({
        type: "ERROR",
        message: errorMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="inventory-modal-overlay"
      onClick={() =>
        !isSubmitting && !isDownloading && setShowRollOutModal(false)
      }
    >
      <div
        className="inventory-modal rollout-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="inventory-modal-header">
          <h3>New Roll Out Mapping</h3>
          <button
            className="close-btn"
            type="button"
            onClick={() =>
              !isSubmitting && !isDownloading && setShowRollOutModal(false)
            }
            disabled={isSubmitting || isDownloading}
          >
            ×
          </button>
        </div>
        <div className="inventory-modal-body">
          <div className="upload-mapping-area">
            <FileUpload
              uploadedFile={uploadedFile}
              setUploadedFile={setUploadedFile}
              handleFileUpload={handleFileUpload}
              handleDownloadSample={handleDownloadSample}
              isUploading={false}
              isDownloading={isDownloading}
              isDisabled={isSubmitting || isDownloading}
              uploadTitle="Upload Mapping File"
              uploadSubtitle=""
              showMappingLayout={true}
              mappingFields={mappingFields}
              mappingNote="(Only system active merchants and only active charging plans can be mapped to devices)"
              fileInputId="mapping-file"
            />
          </div>
        </div>
        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={() =>
              !isSubmitting && !isDownloading && setShowRollOutModal(false)
            }
            disabled={isSubmitting || isDownloading}
          >
            Cancel
          </button>
          <button
            className="submit-btn"
            type="button"
            onClick={handleSubmit}
            disabled={isSubmitting || isDownloading || !uploadedFile}
          >
            {isSubmitting ? "Uploading..." : "Upload Mapping"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RollOutModal;
